import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "plan"
}
const _hoisted_2 = { class: "plan__text" }
const _hoisted_3 = {
  key: 1,
  class: "plan"
}
const _hoisted_4 = { class: "plan__text" }
const _hoisted_5 = { class: "plan__text" }
const _hoisted_6 = { class: "limits-data__text" }
const _hoisted_7 = { class: "limits-data__text" }
const _hoisted_8 = { class: "plan__text" }
const _hoisted_9 = { class: "multi-menu__menu__list__item__icon" }
const _hoisted_10 = { class: "multi-menu__menu__list__item__image" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "multi-menu__menu__list__item__title" }
const _hoisted_13 = { class: "multi-menu__menu__list__item__description" }

import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import moment from 'moment';

import { useAuthStore } from '@/store/auth';
import { useCommonStore } from '@/store/common';
import { useServicesStore } from '@/store/services';

import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';
import AiCountdown from '@/components/UI/AiCountdown/AiCountdown.vue';

import { IMultiMenuItem } from '@/types/IMultiMenuItem';

import { TService } from '@/types/TService';
import { useEditorStore } from '@/store/editor';


export default /*@__PURE__*/_defineComponent({
  __name: 'MultiMenu',
  setup(__props) {

const { t } = useI18n();

const { generateImageData } = storeToRefs(useEditorStore());
const { currentService, isMobile, servicesList } = storeToRefs(useCommonStore());
const { imageResult, imageForActions, sourceBgImage, imagePrev } = storeToRefs(useServicesStore());
const { plan, isAvailable } = storeToRefs(useAuthStore());

const menuOpened = ref<boolean>(false);
const menuList = ref<IMultiMenuItem[]>([
  {
    title: t('multi-menu.market-title'),
    description: t('multi-menu.market-description'),
    color: 'var(--accent-100)',
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/multi-menu/market.svg'),
    image: `${process.env.VUE_APP_URL}/images/multi-menu/generation.png`,
    service: 'create_background_for_image',
  },
  {
    title: t('multi-menu.remove-background-title'),
    description: t('multi-menu.remove-background-description'),
    color: '#FF9EEA',
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/multi-menu/remove-background.svg'),
    image: `${process.env.VUE_APP_URL}/images/multi-menu/remove-background.png`,
    service: 'remove_background',
  },
  {
    title: t('multi-menu.infographics-title'),
    description: t('multi-menu.infographics-description'),
    color: '#86A1FF',
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/multi-menu/infographics.svg'),
    image: `${process.env.VUE_APP_URL}/images/multi-menu/infographics.png`,
    service: 'infographics',
  },
  {
    title: t('multi-menu.upscale-title'),
    description: t('multi-menu.upscale-description'),
    color: '#54FFC1',
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/multi-menu/upscale.svg'),
    image: `${process.env.VUE_APP_URL}/images/multi-menu/upscale.png`,
    service: 'upscale',
  },
  {
    title: t('multi-menu.outpaint-title'),
    description: t('multi-menu.outpaint-description'),
    color: '#FF9839',
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/multi-menu/outpaint.svg'),
    image: `${process.env.VUE_APP_URL}/images/multi-menu/outpaint.png`,
    service: 'outpaint',
  },
  {
    title: t('multi-menu.inpaint-title'),
    description: t('multi-menu.inpaint-description'),
    color: '#919191',
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/multi-menu/inpaint.svg'),
    image: `${process.env.VUE_APP_URL}/images/multi-menu/inpaint.png`,
    service: 'inpaint',
  },
  {
    title: t('multi-menu.shadow-title'),
    description: t('multi-menu.shadow-description'),
    color: '#FFF069',
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/multi-menu/shadow.svg'),
    image: `${process.env.VUE_APP_URL}/images/multi-menu/shadow.png`,
    service: 'shadow',
  },
  {
    title: t('multi-menu.watermarks-title'),
    description: t('multi-menu.watermarks-description'),
    color: '#D1A3FF',
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/multi-menu/watermarks.svg'),
    image: `${process.env.VUE_APP_URL}/images/multi-menu/watermarks.png`,
    service: 'watermarks',
  },
]);

const time = computed(() => {
  const currentDate = moment();
  const userExpDate = moment.utc(plan.value?.expiresAt).local();
  return userExpDate.diff(currentDate);
});

// eslint-disable-next-line max-len
const computedMenuList = computed(() => menuList.value.filter((menuItem: IMultiMenuItem) => servicesList.value.find((serviceItem: string) => menuItem.service === serviceItem)));
// eslint-disable-next-line max-len
const sectionIndex = computed(() => computedMenuList.value.findIndex((menuItem: IMultiMenuItem) => menuItem.service === currentService.value));

const daysLeft = computed(() => {
  const currentDate = moment();
  const expiresAt = moment.utc(plan.value?.expiresAt, 'YYYY-MM-DD HH:mm:ss');

  const diffInDays = expiresAt.diff(currentDate, 'days');
  return diffInDays + 1;
});

const daysQn = computed(() => {
  const connectedAt = moment.utc(plan.value?.connectedAt, 'YYYY-MM-DD HH:mm:ss');
  const expiresAt = moment.utc(plan.value?.expiresAt, 'YYYY-MM-DD HH:mm:ss');
  const diffInDays = expiresAt.diff(connectedAt, 'days');
  return diffInDays;
});

const changeServiceHandler = (service: TService): void => {
  menuOpened.value = false;
  currentService.value = service;
  // if (imageResult.value !== '') {
  sourceBgImage.value = '';
  imageForActions.value = '';
  imagePrev.value = '';
  imageResult.value = '';
  generateImageData.value.products = [];
  // }
};

const endHandler = (): void => {
  isAvailable.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["multi-menu d-flex align-center", { 'multi-menu--opened': menuOpened.value, 'multi-menu--mobile': _unref(isMobile) }])
  }, [
    _createVNode(AiClearButton, {
      class: "multi-menu__button d-flex align-center",
      style: _normalizeStyle({
        'border-color': computedMenuList.value[sectionIndex.value].color,
        background: `rgb(from ${computedMenuList.value[sectionIndex.value].color} r g b / 0.1)`,
      }),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(servicesList).length > 1 ? (menuOpened.value = !menuOpened.value) : null))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "multi-menu__button__text",
          style: _normalizeStyle({ color: computedMenuList.value[sectionIndex.value].color })
        }, _toDisplayString(computedMenuList.value[sectionIndex.value].title), 5)
      ]),
      _: 1
    }, 8, ["style"]),
    _createVNode(_component_v_spacer),
    (_unref(plan)?.name === 'Пробный' && !_unref(isMobile))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('subscriptions.to-plan-end')), 1),
          _createVNode(AiCountdown, {
            time: time.value,
            onEnd: endHandler
          }, null, 8, ["time"])
        ]))
      : (_unref(plan)?.name === 'Безлимитный на 30 дней' && !_unref(isMobile))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('common.left')), 1),
            _createTextVNode(" " + _toDisplayString(daysLeft.value) + " ", 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('common.from')), 1),
            _createTextVNode(" " + _toDisplayString(daysQn.value) + " ", 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('common.d')) + ". ", 1),
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "limits-data__divider" }, " / ", -1)),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(plan).name), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('profile.plan-text')), 1)
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_v_spacer),
    (_unref(servicesList).length > 1)
      ? (_openBlock(), _createBlock(AiClearButton, {
          key: 2,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (menuOpened.value = !menuOpened.value)),
          class: "all-services"
        }, {
          default: _withCtx(() => [
            (!_unref(isMobile))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('multi-menu.all-services')), 1)
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_inline_svg, {
              src: require('@/assets/icons/multi-menu/all.svg'),
              style: _normalizeStyle({ color: computedMenuList.value[sectionIndex.value].color })
            }, null, 8, ["src", "style"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      "model-value": menuOpened.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (menuOpened.value = false)),
      scrim: false,
      "content-class": { 'multi-menu__menu': true, 'multi-menu__menu--mobile': _unref(isMobile) },
      attach: ".app-template",
      absolute: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["multi-menu__menu__list", { 'multi-menu__menu__list--mobile': _unref(isMobile) }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedMenuList.value, (item, index) => {
            return (_openBlock(), _createBlock(AiClearButton, {
              key: index,
              class: "multi-menu__menu__list__item",
              onClick: ($event: any) => (changeServiceHandler(item.service))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("img", {
                      src: item.image,
                      alt: ""
                    }, null, 8, _hoisted_11)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString(item.description), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ], 2)
      ]),
      _: 1
    }, 8, ["model-value", "content-class"])
  ], 2))
}
}

})